import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@node_modules/@angular/router/router';
import { catchError, forkJoin, Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagosAdminService extends UtilidadesCrudService {

  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'pagoAdmin/metodos',
      'pagoAdmin/metodo',
      'Pagos Admin Métodos',
      'Pagos Admin Método',
      [
      ]
    );
  }


  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;   
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}
